import React from 'react';

/**
 * Componente reutilizável: UI de troco/cash change
 */
export default function TrocoCash({ valorRecebido, troco, onValorRecebidoChange }) {
  return (
    <div className="bg-emerald-50 border border-emerald-100 rounded-3xl p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
      <div>
        <div className="text-[10px] font-black text-emerald-700 uppercase tracking-widest mb-2">Valor Recebido (€)</div>
        <input
          type="number"
          step="0.01"
          min="0"
          value={valorRecebido}
          onChange={(e) => onValorRecebidoChange(e.target.value)}
          className="w-full p-4 bg-white rounded-2xl font-black outline-none border border-emerald-100"
        />
      </div>
      <div className="flex flex-col justify-center">
        <div className="text-[10px] font-black text-emerald-700 uppercase tracking-widest mb-2">Troco a Devolver</div>
        <div className="text-3xl font-black text-emerald-800">{troco.toFixed(2)}€</div>
      </div>
    </div>
  );
}





